'use strict';

export function hashCopy(el, event) {
    var sel = $(el).data('sel');
    if (!sel) return;

    var x = event.pageX,
        y = event.pageY;

    if (sel.substr(0, 1) !== '#' && sel.substr(0, 1) !== '.') {
        sel = '.' + sel;
    }

    var sep = $(el).data('sep') || ', ';
    var list = [];
    $(sel).each(function () {
        list.push($(this).text());
    });

    var $tmp = $('<div class="clipboardHtml2"></div>').css({
        top: 5,
        left: 5
    }).text(list.join(sep)).appendTo('body');

    copyHtml($tmp.get(0), function (element, result) {
        copiedCircle(x, y);
        setTimeout(function () {
            $tmp.remove();
        }, 500);
    });
}

function copiedCircle(x, y) {
    if ($('.copiedCircle').length) {
        return;
    }
    var $el = $('<div class="copiedCircle"><div></div></div>');
    $el.css({
        top: y - 35,
        left: x - 35
    });
    $el.appendTo('body');

    setTimeout(function () {
        $el.addClass('copied');
    }, 10);
    setTimeout(function () {
        $el.addClass('done').removeClass('copied');
    }, 1000);

    setTimeout(function () {
        $el.remove();
    }, 5000);
}

function deselectAll() {
    var element = document.activeElement;

    if (element && /INPUT|TEXTAREA/i.test(element.tagName)) {
        if ('selectionStart' in element) {
            // @ts-ignore
            element.selectionEnd = element.selectionStart;
        }
        // @ts-ignore
        element.blur();
    }

    if (window.getSelection) { // All browsers, except IE <=8
        window.getSelection().removeAllRanges();
        // @ts-ignore
    } else if (document.selection) { // IE <=8
        // @ts-ignore
        document.selection.empty();
    }
}

export async function copy(el, onfinish) {
    var done = false;
    if (navigator.clipboard) {
        try {
            await navigator.clipboard.writeText(el.value).then(() => {
                done = true;
            });
        } catch (error) { }
    }

    if (!done) {
        el.focus();
        el.select();
        el.setSelectionRange(0, 99999); // For mobile devices
        document.execCommand("copy");
    }

    deselectAll();

    if (onfinish) {
        onfinish(el);
    }
}

export async function copyHtml(element, onfinish) {
    const htmlContent = element.outerHTML;
    const textContent = element.innerText; // Plain text versija

    // 2. Izveido ClipboardItem ar abiem formātiem
    const blobHtml = new Blob([htmlContent], { type: 'text/html' });
    const blobText = new Blob([textContent], { type: 'text/plain' });

    const data = [new ClipboardItem({
        'text/html': blobHtml,
        'text/plain': blobText
    })];

    var result = false;
    try {
        await navigator.clipboard.write(data);
        result = true;
    } catch (err) {
        console.error("Kļūda kopējot:", err);
    }

    if (onfinish) {
        onfinish(element, result);
    }

    return result;
}

const clipboardTools = {
    hashCopy: hashCopy,
    copy: copy,
    copyHtml: copyHtml
};

// @ts-ignore
window.clipboardTools = clipboardTools;


